module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "m-tagItem"
  }, [_vm._t("default", [_vm._v("タグ名がありません")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-014fc466"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/Tag.vue
// module id = 1277
// module chunks = 0